var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnermatchLogoVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 83,
    viewBox: "0 0 178 83",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_17349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.495 23.4051L82.0386 22.26L89.1145 11.7026L123.114 12.8509L116.495 23.4051Z",
    fill: "url(#paint0_linear_687_17349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.823 37.6336L73.3667 36.4853L80.4426 25.9312L114.442 27.0794L107.823 37.6336Z",
    fill: "url(#paint1_linear_687_17349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.1513 51.8621L64.6948 50.7138L71.7707 40.1597L105.771 41.3047L99.1513 51.8621Z",
    fill: "url(#paint2_linear_687_17349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.681 11.7024L72.228 10.5574L79.3007 0L113.301 1.14825L106.681 11.7024Z",
    fill: "url(#paint3_linear_687_17349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.011 25.9309L63.5577 24.7827L70.6304 14.2285L104.63 15.3735L98.011 25.9309Z",
    fill: "url(#paint4_linear_687_17349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.3423 40.1593L54.8857 39.011L61.9584 28.4536L95.9582 29.6019L89.3423 40.1593Z",
    fill: "url(#paint5_linear_687_17349)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.650879 72.2808C0.650879 70.5698 0.911401 69.069 1.43566 67.7849C1.95671 66.5008 2.645 65.4302 3.49733 64.573C4.34966 63.7159 5.32742 63.069 6.43384 62.6291C7.54025 62.1892 8.67883 61.9692 9.84636 61.9692C12.5706 61.9692 14.7255 62.807 16.3047 64.4824C17.8872 66.1579 18.6784 68.6226 18.6784 71.8765C18.6784 72.1935 18.6655 72.5428 18.6398 72.9213C18.6141 73.3029 18.5916 73.6361 18.5658 73.9304H6.23442C6.35664 75.056 6.87769 75.9487 7.80399 76.6086C8.72708 77.2684 9.96858 77.5983 11.5253 77.5983C12.5223 77.5983 13.5001 77.5078 14.4618 77.3234C15.4235 77.139 16.2083 76.9126 16.8161 76.6442L17.5462 81.0851C17.2536 81.2307 16.8644 81.3795 16.3787 81.525C15.8931 81.6706 15.3495 81.8 14.7545 81.9099C14.1562 82.0199 13.5194 82.1105 12.8375 82.1849C12.1557 82.2593 11.4738 82.2948 10.7952 82.2948C9.06801 82.2948 7.56598 82.0393 6.2891 81.525C5.01222 81.0107 3.95405 80.3089 3.11459 79.4129C2.27512 78.5169 1.65437 77.4625 1.25233 76.2399C0.850291 75.0172 0.650879 73.6943 0.650879 72.2776L0.650879 72.2808ZM13.4229 70.1881C13.3972 69.7223 13.32 69.2695 13.1849 68.8296C13.0498 68.3897 12.844 67.9983 12.5642 67.6555C12.2843 67.3126 11.9305 67.0312 11.506 66.8113C11.0782 66.5913 10.5507 66.4814 9.91712 66.4814C9.2835 66.4814 8.78497 66.5849 8.34755 66.7919C7.91013 67.0021 7.54668 67.2738 7.254 67.6167C6.96131 67.9595 6.73617 68.3574 6.57857 68.8102C6.42097 69.263 6.30518 69.7223 6.23121 70.1881H13.4197H13.4229Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8758 63.1435C23.7989 62.875 24.9921 62.626 26.4524 62.3898C27.9126 62.157 29.4467 62.0405 31.0517 62.0405C32.6566 62.0405 34.0364 62.254 35.1204 62.6842C36.2043 63.1144 37.0598 63.716 37.6934 64.502C38.327 65.2847 38.7741 66.213 39.0443 67.2901C39.3144 68.3672 39.4463 69.5672 39.4463 70.8869V81.7872H34.0075V71.55C34.0075 69.7872 33.7759 68.5386 33.3128 67.8076C32.8496 67.0734 31.9876 66.7079 30.7236 66.7079C30.3345 66.7079 29.9195 66.7273 29.4821 66.7629C29.0447 66.7985 28.6555 66.8438 28.3146 66.8923V81.7904H22.8758V63.1467V63.1435Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4575 72.2808C43.4575 70.5698 43.718 69.069 44.2423 67.7849C44.7633 66.5008 45.4516 65.4302 46.304 64.573C47.1563 63.7159 48.134 63.069 49.2405 62.6291C50.3469 62.1892 51.4855 61.9692 52.653 61.9692C55.3772 61.9692 57.5321 62.807 59.1114 64.4824C60.6938 66.1579 61.485 68.6226 61.485 71.8765C61.485 72.1935 61.4722 72.5428 61.4464 72.9213C61.4207 73.3029 61.3982 73.6361 61.3724 73.9304H49.0378C49.16 75.056 49.6811 75.9487 50.6074 76.6086C51.5305 77.2684 52.772 77.5983 54.3287 77.5983C55.3257 77.5983 56.3035 77.5078 57.2652 77.3234C58.2269 77.139 59.0117 76.9126 59.6195 76.6442L60.3497 81.0851C60.057 81.2307 59.6678 81.3795 59.1821 81.525C58.6965 81.6706 58.1529 81.8 57.5579 81.9099C56.9596 82.0199 56.3228 82.1105 55.6409 82.1849C54.9591 82.2593 54.2772 82.2948 53.5986 82.2948C51.8714 82.2948 50.3694 82.0393 49.0925 81.525C47.8156 81.0107 46.7575 80.3089 45.918 79.4129C45.0785 78.5169 44.4578 77.4625 44.0557 76.2399C43.6537 75.0172 43.4543 73.6943 43.4543 72.2776L43.4575 72.2808ZM56.2295 70.1881C56.2038 69.7223 56.1266 69.2695 55.9915 68.8296C55.8564 68.3897 55.6506 67.9983 55.3708 67.6555C55.091 67.3126 54.7372 67.0312 54.3126 66.8113C53.8848 66.5913 53.3574 66.4814 52.7237 66.4814C52.0901 66.4814 51.5916 66.5849 51.1542 66.7919C50.7168 67.0021 50.3533 67.2738 50.0606 67.6167C49.7679 67.9595 49.5428 68.3574 49.3852 68.8102C49.2276 69.263 49.1118 69.7223 49.0378 70.1881H56.2263H56.2295Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.2513 67.326C76.7656 67.203 76.1931 67.0769 75.537 66.941C74.8808 66.8084 74.1732 66.7405 73.4206 66.7405C73.0797 66.7405 72.6712 66.7728 72.1984 66.8343C71.7224 66.8958 71.3654 66.9604 71.1209 67.0348V81.7874H65.6821V63.5125C66.6535 63.1696 67.8049 62.8462 69.13 62.5389C70.4552 62.2316 71.9347 62.0796 73.5653 62.0796C73.858 62.0796 74.2086 62.099 74.6235 62.1346C75.0352 62.1702 75.4501 62.2187 75.865 62.2801C76.2767 62.3416 76.6916 62.416 77.1065 62.5001C77.5182 62.5842 77.872 62.6909 78.1647 62.8106L77.2513 67.326Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.668 63.4736C82.3723 63.2795 83.2922 63.0596 84.4244 62.8137C85.5565 62.5679 87.0199 62.4482 88.8211 62.4482C91.2044 62.4482 92.9315 63.1469 94.0026 64.541C94.1248 64.4439 94.3628 64.279 94.7134 64.0461C95.0672 63.8132 95.511 63.5771 96.045 63.3313C96.5789 63.0854 97.206 62.8784 97.9233 62.707C98.6405 62.5356 99.4382 62.4482 100.313 62.4482C101.747 62.4482 102.912 62.6617 103.8 63.0919C104.687 63.5221 105.376 64.1205 105.861 64.8903C106.347 65.6601 106.678 66.5852 106.849 67.6623C107.019 68.7393 107.103 69.9135 107.103 71.1846V81.7906H104.732V71.9544C104.732 70.7059 104.678 69.6224 104.568 68.707C104.459 67.7884 104.24 67.0315 103.912 66.4299C103.584 65.8315 103.114 65.3787 102.507 65.0714C101.899 64.7641 101.107 64.6121 100.133 64.6121C99.4028 64.6121 98.7402 64.68 98.1452 64.8127C97.5502 64.9485 97.0324 65.1135 96.5949 65.3075C96.1575 65.5048 95.7973 65.6989 95.5175 65.893C95.2377 66.0903 95.0382 66.2358 94.916 66.3329C95.1347 66.9701 95.2988 67.6849 95.4081 68.4806C95.5175 69.2763 95.5722 70.114 95.5722 70.9938V81.7841H93.2017V71.948C93.2017 70.6995 93.147 69.6159 93.0377 68.7005C92.9283 67.7819 92.7032 67.0251 92.3623 66.4234C92.0213 65.8251 91.5421 65.3722 90.9213 65.065C90.3006 64.7577 89.4804 64.6057 88.4576 64.6057C87.3158 64.6057 86.3477 64.6671 85.5565 64.79C84.7653 64.9129 84.2603 65.0229 84.0416 65.1199V81.7809H81.668V63.4671V63.4736Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.89 62.3735C120.132 62.3735 121.184 62.5514 122.049 62.9072C122.911 63.263 123.612 63.7514 124.149 64.3757C124.683 65 125.072 65.7406 125.317 66.5946C125.561 67.4517 125.68 68.38 125.68 69.3827V81.3471C125.436 81.4215 125.085 81.4991 124.622 81.5865C124.159 81.6738 123.625 81.7644 123.017 81.8614C122.409 81.9584 121.734 82.0393 120.991 82.1008C120.248 82.1622 119.489 82.1913 118.71 82.1913C117.713 82.1913 116.797 82.0813 115.954 81.8614C115.114 81.6415 114.384 81.2921 113.764 80.8167C113.143 80.3379 112.657 79.7266 112.303 78.9827C111.95 78.2355 111.773 77.3266 111.773 76.2495C111.773 75.1725 111.966 74.3412 112.355 73.607C112.744 72.8727 113.291 72.2679 113.998 71.7892C114.706 71.3105 115.542 70.9644 116.517 70.7444C117.488 70.5245 118.55 70.4145 119.691 70.4145C120.032 70.4145 120.389 70.4339 120.769 70.4695C121.145 70.5051 121.512 70.5536 121.862 70.615C122.216 70.6765 122.518 70.738 122.776 70.7994C123.03 70.8609 123.207 70.9159 123.306 70.9644V69.7902C123.306 69.1304 123.258 68.4867 123.162 67.8625C123.065 67.2382 122.85 66.6754 122.525 66.1741C122.197 65.6727 121.734 65.2684 121.139 64.9611C120.54 64.6571 119.759 64.5018 118.784 64.5018C117.398 64.5018 116.362 64.5989 115.684 64.7962C115.002 64.9935 114.503 65.152 114.188 65.2749L113.86 63.1822C114.272 62.9881 114.912 62.8037 115.777 62.6323C116.639 62.4609 117.681 62.3768 118.897 62.3768L118.89 62.3735ZM119.109 80.063C120.032 80.063 120.843 80.0339 121.534 79.9692C122.229 79.9078 122.818 79.8301 123.303 79.7299V73.0506C123.036 72.9277 122.609 72.8016 122.026 72.6657C121.444 72.5299 120.64 72.4652 119.617 72.4652C119.035 72.4652 118.427 72.5072 117.794 72.5913C117.16 72.6787 116.578 72.8598 116.044 73.1412C115.507 73.4226 115.069 73.8075 114.729 74.2991C114.388 74.7908 114.217 75.4377 114.217 76.2431C114.217 76.9514 114.333 77.553 114.564 78.0415C114.796 78.5299 115.124 78.9212 115.552 79.2156C115.976 79.5099 116.488 79.7234 117.083 79.8592C117.678 79.9951 118.353 80.0598 119.109 80.0598V80.063Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.961 62.8137H141.478V64.832H133.961V74.9236C133.961 76.0007 134.051 76.874 134.234 77.5468C134.418 78.2196 134.678 78.7403 135.019 79.1058C135.36 79.4713 135.772 79.7172 136.261 79.8401C136.746 79.963 137.28 80.0244 137.866 80.0244C138.863 80.0244 139.664 79.908 140.275 79.6751C140.883 79.4422 141.359 79.2288 141.7 79.0314L142.282 81.0142C141.941 81.2341 141.346 81.4864 140.493 81.7678C139.641 82.0492 138.718 82.1883 137.721 82.1883C136.553 82.1883 135.572 82.0363 134.781 81.729C133.99 81.4217 133.36 80.9592 132.884 80.3349C132.408 79.7107 132.073 78.9344 131.88 78.0029C131.687 77.0746 131.587 75.9716 131.587 74.7005V57.2309L133.958 56.791V62.8104L133.961 62.8137Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.667 82.191C152.207 82.191 150.917 81.9581 149.798 81.4956C148.679 81.0298 147.749 80.3635 147.006 79.4967C146.263 78.6266 145.697 77.5883 145.308 76.3754C144.919 75.1657 144.726 73.8234 144.726 72.3581C144.726 70.8929 144.925 69.5085 145.328 68.2859C145.73 67.0633 146.305 66.0088 147.061 65.129C147.814 64.2492 148.727 63.57 149.798 63.0913C150.869 62.6126 152.072 62.3765 153.413 62.3765C154.433 62.3765 155.388 62.4638 156.279 62.632C157.167 62.8034 157.855 63.0234 158.341 63.2918L157.72 65.3457C157.231 65.0999 156.684 64.9058 156.076 64.7603C155.469 64.6147 154.652 64.5403 153.632 64.5403C151.538 64.5403 149.953 65.2196 148.869 66.5781C147.785 67.9366 147.244 69.8611 147.244 72.3581C147.244 73.4837 147.367 74.5188 147.608 75.46C147.852 76.4013 148.248 77.2099 148.795 77.8827C149.341 78.5554 150.049 79.0794 150.911 79.4611C151.773 79.8428 152.825 80.0304 154.066 80.0304C155.089 80.0304 155.948 79.9139 156.639 79.681C157.331 79.4482 157.836 79.2476 158.154 79.0762L158.666 81.1333C158.228 81.3792 157.54 81.6153 156.604 81.8482C155.668 82.081 154.69 82.1943 153.667 82.1943V82.191Z",
    fill: "#2E8267"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.644 81.7871V53.7504L165.018 53.3105V63.3666C165.796 63.0723 166.587 62.8491 167.388 62.6874C168.189 62.5289 168.993 62.448 169.797 62.448C171.257 62.448 172.473 62.6583 173.448 63.0723C174.419 63.4863 175.197 64.0814 175.783 64.8512C176.365 65.6211 176.773 66.5461 177.005 67.6232C177.237 68.7003 177.349 69.8874 177.349 71.1844V81.7903H174.979V71.9542C174.979 70.6087 174.889 69.4701 174.705 68.5418C174.522 67.6135 174.22 66.8534 173.792 66.2647C173.364 65.6793 172.801 65.2556 172.094 65C171.389 64.7445 170.502 64.6151 169.43 64.6151C169.019 64.6151 168.575 64.6507 168.099 64.7251C167.623 64.7995 167.179 64.8771 166.767 64.9645C166.356 65.0518 165.983 65.1424 165.655 65.2394C165.326 65.3364 165.114 65.4108 165.018 65.4593V81.7903H162.644V81.7871Z",
    fill: "#2E8267"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_687_17349",
    x1: 82.0386,
    y1: 17.5538,
    x2: 123.114,
    y2: 17.5538,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#99C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4C9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#469389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#378976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_687_17349",
    x1: 73.3667,
    y1: 31.7824,
    x2: 114.442,
    y2: 31.7824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#99C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4C9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#469389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#378976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_687_17349",
    x1: 64.6948,
    y1: 46.0109,
    x2: 105.771,
    y2: 46.0109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#99C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4C9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#469389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#378976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_687_17349",
    x1: 72.228,
    y1: 5.85121,
    x2: 113.301,
    y2: 5.85121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#99C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4C9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#469389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#378976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_687_17349",
    x1: 63.5577,
    y1: 20.0797,
    x2: 104.63,
    y2: 20.0797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#99C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4C9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#469389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#378976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8065"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_687_17349",
    x1: 54.8857,
    y1: 34.3048,
    x2: 95.9582,
    y2: 34.3048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EFC86E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#99C981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#4C9791"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#469389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#378976"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A8065"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_17349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176.698,
    height: 82.2947,
    fill: "white",
    transform: "translate(0.650879)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnermatchLogoVertical);
export default __webpack_public_path__ + "static/media/enermatch-logo-vertical.cfbd6e85db963da7f5da9679b51dfe62.svg";
export { ForwardRef as ReactComponent };